import axios from 'axios'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useDataLayer } from '../../hooks/useDataLayer'

const ToolOverlayContext = createContext({})

const ToolOverlayProvider = props => {
  const dataLayer = useDataLayer()
  const [isToolOverlayOpen, setToolOverlayOpen] = useState(false)
  const [contextSectionLimit, setContextSectionLimit] = useState(null)
  const [plz, setPlz] = useState('')
  const [people, setPeople] = useState([])
  const [data, setData] = useState(null)

  const preload = () => {
    if (data) {
      return Promise.resolve(data)
    }

    return axios
      .get('https://cmslift.ch/csvupload/AS_PLZ_Liste.csv')
      .then(res => {
        const lines = res.data.split('\n')
        setData(lines)

        return lines
      })
  }

  const handleSubmit = (e, newPlz) => {
    e.preventDefault()
    setPlz(newPlz)
    setPeople([])

    dataLayer.push({
      event: 'userinteraction',
      eventCategory: 'Standortsuche',
      eventAction: 'submit',
      eventLabel: newPlz,
      event_location: null,
    })

    preload().then(lines => {
      const people = []

      lines.forEach(line => {
        if (people.length > 0) {
          return
        }

        const fields = line.split(';')

        if (fields.length > 0 && `${fields[0]}` === `${newPlz}`) {
          people.push(...fields.slice(4))
        }
      })

      setPeople(people)
    })
  }

  const findCityName = plz => {
    const lines = data || []

    const matchingPlz = lines.find(line => {
      const fields = line.split(';')

      return fields.length > 0 && `${fields[0]}` === `${plz}`
    })

    if (!matchingPlz) {
      return ''
    }

    const result = `${matchingPlz.split(';')[1]}, ${matchingPlz.split(';')[2]}`
    if (result.trim() !== ',') {
      return result
    }

    return ''
  }

  useEffect(() => {
    if (!isToolOverlayOpen) {
      setPlz('')
      setPeople([])
      setContextSectionLimit(null)
    }
  }, [isToolOverlayOpen])

  return (
    <ToolOverlayContext.Provider
      value={{
        isToolOverlayOpen,
        plz,
        people,
        contextSectionLimit,
        setContextSectionLimit,
        setToolOverlayOpen,
        setPlz,
        setPeople,
        preload,
        findCityName,
        handleSubmit,
      }}
      {...props}
    />
  )
}

const useToolOverlay = () => useContext(ToolOverlayContext)

export { ToolOverlayContext, ToolOverlayProvider, useToolOverlay }
